import React from "react";

import ManageStores from "../../components/ManageStores";

export default function Stores() {
  return <ManageStores />;
}
